import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import iceBreakerApi from '../api/iceBreakerApi';
import iceBreakerModel from '../models/iceBreaker';
import IceBreaker from '../models/iceBreaker';
class IceBreakerService {
  loadAll(): Promise<IApiResponse> {
    return iceBreakerApi.loadAll().then(res => {
      try {
        if (res.success && res.data && res.data.items) {
          res.data.items = iceBreakerModel.mappingObjects(res.data.items);
        } else {
          console.log('ERROR: iceBreakerService/loadAll:', res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: iceBreakerService/loadAll:', e);
        throw new Error('failed');
      }
    });
  }
}

export default new IceBreakerService();
